export const operacaoFilterConfig = [
  {
    id: 'NomeOperacao',
    type: 'text',
    label: 'Nome Operação',
    placeholder: 'Digite o nome da operação'
  }
];
